<div *ngIf="dsr || packingSlip" class="dsr-page">
  <div class="dsr-content" data-test="report-section">
    <div *ngIf="dsr" [innerHTML]="dsr" data-test="dsr-section"></div>
    <div
      *ngIf="packingSlip"
      #packingSlipSection
      [innerHTML]="packingSlip"
      class="packing-slip"
      data-test="packing-slip-section"></div>
  </div>
  <div class="dsr-header" data-test="close-button-section">
    <button (click)="closeWindow()">Close</button>
    <p class="status-message">Order Successfully Submitted</p>
  </div>
</div>
